import React, {useState} from 'react';
import * as R from 'ramda';
import {Row, Col} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import Select from '@/Form/Select';
import download from '@/assets/images/download.png';
import DownloadFileButton from '@/views/shared/DownloadFileButton';
import {present} from '@/util';
import styles from '@/b2c/PlanDetail/index.module.css';

const SelectMonth = ({capId, monthOptions}) => {
  const {t: tr} = useTranslation('statements');
  const [month, setMonth] = useState('');

  const buildSelectOptions = R.map(([key, val]) => (
    <option value={val} key={val}>
      {key}
    </option>
  ));

  const onChangeMonth = e => {
    setMonth(e.currentTarget.value);
  };

  const downloadPath = R.ifElse(
    present,
    R.always(
      `/statement/download_monthly_statement?month=${month}&party_id=${capId}`
    ),
    R.always(`/statement/${capId}.pdf?request=b2c`)
  )(month);

  return (
    <Row>
      <Col md='auto' sm='4' xs='4'>
        <span className={styles.text_vendor}>{tr('monthly_statement')}</span>
      </Col>
      <Col md='auto' sm='6' xs='6' className='px-0'>
        <Select name='selectedMonth' onChange={onChangeMonth} value={month}>
          {buildSelectOptions(monthOptions)}
        </Select>
      </Col>
      <Col md='auto' sm='1' xs='1' className='px-0'>
        <DownloadFileButton className='btn btn-link btn-sm' path={downloadPath}>
          <img alt='Download' src={download} />
        </DownloadFileButton>
      </Col>
    </Row>
  );
};

export default SelectMonth;
